import * as React from "react";
import { MemoriaBase } from "./MemoriaBase";
import { NFE_CONFIG } from "./memoriaConfigs";

export const MemoriaNfe = () => <MemoriaBase config={NFE_CONFIG} />;

export default MemoriaNfe;
